<div id="phenological-images">
  @if (!loading) {
    @if ((weatherSoilPestChangeDeviceService.phenologyDevices$ | async)?.length > 0) {
      <div class="change-device-container">
        <dk-button
          [label]="'doktar_app.services.weather_soil_and_pest.change_device_title' | translate"
          severity="secondary"
          (onClick)="onClickChangeDeviceBtn($event)" />

        <app-weather-soil-pest-change-device-popover [deviceLineCode]="deviceLineCodesEnum.PHENOLOGY" />
      </div>
      @if (!wasThereAnError) {
        @if (phenologicalImagesResponse?.images?.items?.length > 0) {
          <p>
            {{  phenologicalImagesResponse.currentWeek ? ('doktar_app.common.week_x' | translate: { arg1: phenologicalImagesResponse.currentWeek }) : '' }}
          </p>
          <div class="slider">
            <div class="slides-container" #slidesContainerEl>
              <swiper-container
                #swiperContainer
                navigation="false"
                pagination="true"
                scrollbar="false"
                space-between="15"
                slides-per-view="auto"
                slides-per-group="1"
                centered-slides="false"
                loop="false">
                @for (item of phenologicalImagesResponse?.images?.items ?? []; track item.imageId) {
                  <swiper-slide>
                    <div class="slide">
                      <img [src]="item.imageUrl" alt="" />
                      <span class="image-date-time">
                        {{
                          item.captureDateTime | luxonFormat: 'd LLLL yyyy HH:mm' : 'UTC' + selectedPlantation.offSet
                        }}
                      </span>
                    </div>
                  </swiper-slide>
                }
              </swiper-container>
            </div>


            <i class="ph-fill ph-caret-circle-left back-slide-icon" 
              [ngClass]="{'disabled': activeSlideIndex === 0}"
              (click)="goToPreviousSlide()"></i>
            @if (activeSlideIndex < totalCount - 1) {
              @if (!loadMoreLoading) {
                <i class="ph-fill ph-caret-circle-right next-slide-icon" (click)="goToNextSlide()"></i>
              } @else {
                <div class="spinner-div">
                  <i class="pi pi-spin pi-spinner-dotted"></i>
                </div>
              }
            }
          </div>
        } @else {
          <div class="px-3 centerise">
            <app-weather-soil-pest-nodata-container />
          </div>
        }
      } @else {
        <div class="px-3 centerise">
          <app-weather-soil-pest-error-container
            [selectedPlantation]="selectedPlantation"
            (retry)="getPhenologicalImages()" />
        </div>
      }
    } @else {
      <!-- <app-no-phenology-device-container /> -->
      <app-weather-soil-pest-add-confirm-device
        deviceLineName="phenocam"
        wrongDeviceMessage="Only phenology devices can be added!" />
    }
  } @else {
    <p-skeleton width="100%" height="400px" />
  }
</div>
